import { FieldRenderProps } from 'react-final-form'

const showRealtimeError = (meta: FieldRenderProps['meta']) => {
  const { touched, error, submitError, dirtySinceLastSubmit, submitting } = meta

  return touched && (error || (submitError && !dirtySinceLastSubmit)) && !submitting
}

export default showRealtimeError
